(function () {
  if (window.__freeFromStripMarquee) return;
  window.__freeFromStripMarquee = true;

  var ATTR = 'data-ffs-marquee';

  function fillStrip(strip) {
    var track = strip.querySelector('.free-from-strip__track');
    if (!track) return;

    var original = track.querySelector('.free-from-strip__group');
    if (!original) return;

    track.style.animation = 'none';
    track.style.transform = 'none';

    while (track.children.length > 1) {
      track.removeChild(track.lastElementChild);
    }

    var groupWidth = original.offsetWidth;
    var parentWidth = strip.clientWidth;
    if (groupWidth <= 0 || parentWidth <= 0) {
      track.style.animation = '';
      track.style.transform = '';
      return;
    }

    var copies = Math.max(2, Math.ceil(parentWidth / groupWidth) + 1);
    for (var i = 1; i < copies; i++) {
      var clone = original.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    track.style.setProperty('--free-from-strip-shift', groupWidth + 'px');
    track.offsetHeight;
    track.style.animation = '';
    track.style.transform = '';
  }

  function init() {
    var strips = document.querySelectorAll('.free-from-strip');
    for (var i = 0; i < strips.length; i++) {
      fillStrip(strips[i]);
      strips[i].setAttribute(ATTR, '');
    }
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(init);
  }

  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
